// NOTE :
// DO NOT TOUCH IF YOU DONT UNDERSTAND IT HOW ITS WORK !!
// THIS IS ONLY BRINGING BETWEEN MODULE AND FRONT HTML !!
// ------------------------------------------------------

// make it same name between this {}.vue and {}.html __________________________
<template src="./../layouts/DynamicFormLayout.html"></template>

<script>
import { defineComponent
        , reactive
        , ref
        , onMounted
        , onUnmounted
        , computed
        , watch
        , shallowRef
        , markRaw
    }               from 'vue'

// import CryptoJS         from 'crypto-js'
import DOMPurify                from 'dompurify'
import { Vue3Lottie }           from 'vue3-lottie'
import lottieLoading            from '../../assets/loading.json'
import Swal                     from 'sweetalert2' 
import flatPickr                from 'vue-flatpickr-component';

import 'vue-select/dist/vue-select.css'
import 'flatpickr/dist/flatpickr.css';
// import 'flatpickr/dist/themes/dark.css';

// Form Utilities
import { 
      parseFieldConfig 
    , new_initializeFormData
    , getGridStyle
    , getContainerWidthClass
    , getSectionWidthStyle
    , HitBackEnd 
}                               from '@/utils/formUtilsNew'

// AgGrid Setup
import { AgGridVue }            from 'ag-grid-vue3'
// import { GridGenerator }    from '../../utils/GridGenerator'

import { 
      LightAgGridDark
    , LightAgGrid
    , paginationPageSize
    , paginationPageSizeSelector
    , defaultColDef }           from '../../utils/agGrid'

import DetailModal              from '../../utils/DetailModal.vue'
import ChartWidget              from '../widgets/ApexChartWidget.vue'
import VueApexCharts            from 'vue3-apexcharts'
import Editor                   from 'primevue/editor';
import VueSelect                from 'vue-select'
import DropZone                 from 'dropzone-vue'

import 'dropzone-vue/dist/dropzone-vue.common.css';

// Package from vue-paint
import { 
      VpEditor
    , VpToolbar
    , useAllTools
    , useArrow
    , useEraser
    , useLine
    , useRectangle
    , useMove
    , useBackground
    , urlToBlob
    , downloadSvg
    , createSettings 
}  from 'vue-paint'

// Package for calendar
import FullCalendar             from '@fullcalendar/vue3'
import classicThemePlugin       from '@fullcalendar/vue3/themes/breezy'
import dayGridPlugin            from '@fullcalendar/vue3/daygrid'
import interactionPlugin        from '@fullcalendar/vue3/interaction'
import allLocales               from '@fullcalendar/vue3/locales-all'

import '@fullcalendar/vue3/skeleton.css'
import '@fullcalendar/vue3/themes/breezy/theme.css'
import '@fullcalendar/vue3/themes/breezy/palettes/indigo.css'

//Package for map
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";

import dataChart                from '@/apps/jsonForm/dummy.json'
import moment                   from 'moment'

// Define component for default if caller module not passing parameter 
export default defineComponent({
    name      : 'DynamicFormLayout',
    emits     : [
          'approval_refresh'
        , 'reject_refresh'
    ],
    components: { 
          AgGridVue
        , DetailModal
        , ChartWidget
        , Vue3Lottie
        , VueApexCharts
        , VueSelect
        , 'flat-pickr': flatPickr
        , FullCalendar
        , Editor
        , LMap
        , LTileLayer
        , LMarker
        , LPopup
        , LIcon
        , VpEditor
        , VpToolbar
        , DropZone
        , useArrow
        , useLine
        , useRectangle
        , useEraser
        , useMove
        , urlToBlob
        , useAllTools
        , createSettings
    },
    props     : {
        config: {
              type     : Object
            , required : true
        },
        handlers: { 
              type    : Object
            , default : () => ({})
        },
        alert_type: {
            type    : String,
            default : 'sweetalert'
        },
        type_menu: {
            type    : String,
            default : ''
        },
        date_single: { 
              type   : Object
            , default: () => ({
                  wrap      : false
                , dateFormat: 'Y-m-d'
                , altFormat : 'Y-m-d'
                , altInput  : true
                , locale    : {
                    rangeSeparator: " - "
                }                
                , mode      : "single"
                , minDate    : "today"
            })
        },
        date_range: { 
              type   : Object
            , default: () => ({
                  wrap       : false
                , dateFormat : 'Y-m-d'
                , altFormat  : 'Y-m-d'
                , altInput   : true
                , locale     : {
                    rangeSeparator: " - "
                }                
                , mode       : "range"
                , minDate    : "today"
            })
        },
        date_multi: { 
              type   : Object
            , default: () => ({
                  wrap       : false
                , dateFormat : 'Y-m-d'
                , mode       : "multiple"
                , altFormat  : 'Y-m-d'
                , altInput   : true
                , locale     : {
                    rangeSeparator: " - "
                }                
            })
        },
        date_time: { 
              type   : Object
            , default: () => ({
                  wrap       : false
                , dateFormat : 'Y-m-d H:i'
                , altInput   : true
                , time_24hr  : true
                , enableTime : true
                , minDate    : "today"
            })
        },
        time_picker: { 
              type   : Object
            , default: () => ({
                  wrap       : false
                , enableTime : true
                , noCalendar : true
                , dateFormat : "H:i"
                , time_24hr  : true                
            })
        },
        config_cal: { 
              type   : Object
            , default: () => ({
                selectable      : true
                , editable      : true
                , locale        : 'id'
            })
        },
        config_paint: {
              type   : Object
            , default: () => ({
                  backgroundImage   : "/background.png"
                , backgroundColor   : "transparent"
                , tools             : null
                , colors            : [
                    '#6b7280',
                    '#ef4444',
                    '#f59e0b',
                    '#eab308',
                    '#22c55e',
                    '#14b8a6',
                    '#06b6d4',
                    '#3b82f6',
                    '#8b5cf6',
                    '#ec4899',
                ]

            })
        },
        config_video: {
              type   : Object
            , default: () => ({})
        },
        direct_row_data: {
              type: Array
            , default: () => []
        },
        direct_column_defs: {
              type: Array
            , default: () => []
        },
        direct_custom_formats: {
            type: Object
            , default: () => ({})
        },
        direct_hidden_fields: {
            type: Array
            , default: () => []
        },
        direct_loading: {
            type: Boolean
            , default: false
        },
        direct_custom_columns: {
            type: Object
            , default: () => ({})
        },
    },
    setup(props) {
        // Use reactive prop directly
        const formConfig     = computed(() => props.config)
        const formData       = reactive({})
        const activeTabIndex = ref(0)
        const alert_type     = props.alert_type
        const rawMetrics     = ref({})
        const mapMarkers     = ref({})
        const typeMenu       = computed(() => props.type_menu) 

        // AG-Grid Direct without handle
        const directRow      = computed(() => props.direct_row_data)
        const directColumn   = computed(() => props.direct_column_defs)
        const directHidden   = computed(() => props.direct_hidden_fields)
        const directLoading  = computed(() => props.direct_loading)
        const isCheckModal   = computed(() => props.is_check_modal)
        const directCustomCol= computed(() => props.direct_custom_columns)
        const directCustomFor= computed(() => props.direct_custom_formats)
        
        // Get user profile
        const userProfile    = ref(JSON.parse(localStorage.getItem('user_profile')))
        const username       = computed(() => userProfile.value?.username ?? '')
        const level          = computed(() => userProfile.value?.user_level ?? '')

        formData.fullname    = username

        // Prepare for passing throught to front html
        const DateSingle     = computed(() => props.date_single)
        const DateRange      = computed(() => props.date_range)
        const DateMulti      = computed(() => props.date_multi)
        const DateTime       = computed(() => props.date_time)
        const TimePicker     = computed(() => props.time_picker)
        const configCalendar = computed(() => props.config_cal)
        const configPaint    = computed(() => props.config_paint)
        const configVideo    = computed(() => props.config_video)

        // Dark Mode Handling
        const isDark         = ref(document.documentElement.classList.contains('dark'))
        let   observer       = null

        // Switch grid to dark or light
        const AgGridDark     = computed(() => isDark.value ? LightAgGridDark : LightAgGrid)
        const CalendarDark   = computed(() => isDark.value ? 'dark' : 'light')
        const ChartDark      = computed(() => isDark.value ? 'dark' : 'light')

        // events array for calendardark
        const events         = ref([])

        // Add an Event on the calendar
        function addEventsCalendar(title, start) {
            if (!title) return;

            events.value.push({
                  id    : String(moment())
                , title : title
                , start : start
            })
        }
        
        // Handle when date clicked directly
        function handleDateClick(info) {
            Swal.fire({
                title              : `Add event for ${moment(info.dateStr).format('LL')}`,
                input              : "text",
                inputAttributes    : { autocapitalize: "off" },
                showCancelButton   : true,
                confirmButtonText  : "Add Events",
                showLoaderOnConfirm: true,
                preConfirm         : async (eventsTitle) => {
                    try {
                        if (eventsTitle) {
                            addEventsCalendar(eventsTitle, info.dateStr)
                        }
                    } catch (error) {
                        Swal.showValidationMessage(`
                            Request failed: ${error}
                        `);
                    }
                },
                allowOutsideClick: () => !Swal.isLoading()
            });
        }

        // Handle when event clicked
        function handleEventClick(params) {
            Swal.fire({
                title             : "Wanna view detail or delete event",
                inputAttributes   : { autocapitalize: "off" },
                showDenyButton    : true,
                confirmButtonText : "View",
                denyButtonText    : "Delete",
                denyButtonColor   : "#d33",
                allowOutsideClick : () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: params.event.title,
                        text : params.view.type,
                        icon : "info"
                    })

                } else if (result.isDenied) {
                    // console.log("🚀 ~ handleEventClick ~ bad")
                    Swal.fire({
                        title             : `Delete event "${params.event.title}"?`,
                        text              : "Deleted event can't be undo!",
                        icon              : 'warning',
                        showCancelButton  : true,
                        confirmButtonText : "Yes, Delete!",
                        cancelButtonText  : "Cancel",
                        confirmButtonColor: '#d33',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            params.event.remove()
                            events.value = events.value.filter(event => event.id !== params.event.id)
                            Swal.fire('Deleted!', 'Event has been deleted succesfuly.', 'success')
                        }
                    })
                }
            });
        }

        // Handle Custom button for add events
        function handleCustomButton() {
            Swal.fire({
                title            : "Please add title for the event",
                input            : "text",
                inputAttributes  : { autocapitalize: "off" },
                showCancelButton : true,
                confirmButtonText: "Continue",
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    const eventTitle = result.value;

                    Swal.fire({
                        title            : "Please add date for the event",
                        input            : "date",
                        inputAttributes  : { autocapitalize: "off" },
                        showCancelButton : true,
                        confirmButtonText: "Add Event",
                        allowOutsideClick: () => !Swal.isLoading()
                    }).then((response) => {
                        // console.log("🚀 ~ handleCustomButton ~ title:", eventTitle);
                        // console.log("🚀 ~ handleCustomButton ~ date:", response.value);

                        if (response.isConfirmed && response.value) {
                            addEventsCalendar(eventTitle, response.value);
                        }
                    });
                }
            });
        }

        function formatTitle(key) {
            return key
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase())
        }

        const getFlexStyle = (size) => {
            switch (size) {
                case 'sm'   : return 'flex-1 min-w-[280px] max-w-full'
                case 'md'   : return 'flex-[2_2_400px] min-w-[320px] max-w-full'
                case 'lg'   : return 'flex-[3_3_600px] min-w-[350px] max-w-full'
                case 'half' : return 'w-full md:w-[calc(50%-0.5rem)] flex-none'
                case '1/3'  : return 'w-full md:w-[calc(33.333%-0.67rem)] flex-none'
                case '2/3'  : return 'w-full md:w-[calc(66.666%-0.33rem)] flex-none'
                case 'full' : return 'w-full flex-none'
                default     : return 'flex-1 min-w-[280px] max-w-full'
            }
        }

        async function handleChart() {
            if (!formConfig.value?.layout) return;

            // Fungsi helper rekursif untuk menyisir semua bagian layout
            const extractCharts = (items) => {
                if (!Array.isArray(items)) return;

                items.forEach((content) => {
                    // Jika menemukan field bertipe chart
                    if (content.type === "chart") {
                        try {
                            // const dataChart = await HitBackEnd('https://api.open-meteo.com/v1/forecast?latitude=-6.2088&longitude=106.8456&hourly=temperature_2m,precipitation', "POST", {})
                            
                            const chartKey   = parseFieldConfig(content.id).key;
                            const chartLabel = parseFieldConfig(content.id).label;
                            const isPieOrDoughnut = ['pie', 'doughnut', 'donut'].includes(content.chartType);

                            if (isPieOrDoughnut) {
                                // Format ApexCharts khusus Pie / Donut
                                rawMetrics.value[chartKey] = {
                                    chartOptions: {
                                        chart: {
                                            id: chartKey,
                                            type: content.chartType === 'doughnut' ? 'donut' : content.chartType,
                                        },
                                        labels: dataChart[chartKey].xaxis || ['Device A', 'Device B', 'Device C'], // Kategori/Label Pie
                                        title: {
                                            text: content.title || chartLabel,
                                        },
                                        theme: {
                                            mode: isDark.value ? 'dark' : 'light'
                                        },                                        
                                        legend: {
                                                show: false,
                                            },
                                            plotOptions: {
                                                pie: {
                                                    dataLabels: {
                                                        external: {
                                                            show: true,
                                                        },
                                                    },
                                                },
                                            },
                                    },
                                    // Pie/Donut series HANYA butuh Array angka sederhana [44, 55, 13]
                                    series: dataChart[chartKey].data || [44, 55, 13]
                                };
                            } else {
                                rawMetrics.value[chartKey] = {
                                    chartOptions: {
                                        chart: {
                                            id: chartKey,
                                            type: content.chartType || 'bar',
                                        },
                                        xaxis: {
                                            categories: dataChart[chartKey].xaxis || ['Jan', 'Feb', 'Mar']
                                        },
                                        title: {
                                            text: content.title || chartLabel,
                                        },
                                        theme: {
                                            mode: isDark.value ? 'dark' : 'light'
                                        }
                                    },
                                    series: [
                                        {
                                            name: chartLabel,
                                            data: dataChart[chartKey].data || [30, 40, 45]
                                        }
                                    ]
                                };
                            }
                            

                        } catch (error) {
                            console.log("🚀 ~ handleChart ~ error:", error)
                        }
                    }

                    // Jika item ini punya sub-layout / nested layout
                    if (Array.isArray(content.layout)) {
                        extractCharts(content.layout);
                    }

                    // Jika item ini punya array input
                    if (Array.isArray(content.input)) {
                        extractCharts(content.input);
                    }
                });
            };

            extractCharts(formConfig.value.layout);
            // console.log("🚀 Hasil rawMetrics:", rawMetrics.value);
        }

        async function handleMap() {
            if (!formConfig.value?.layout) return;

            // Fungsi helper rekursif untuk menyisir semua bagian layout
            const extractMap = (items) => {
                if (!Array.isArray(items)) return;

                items.forEach((content) => {
                    // Jika menemukan field bertipe chart
                    if (content.type === "map") {
                        try {
                            
                            const mapKey   = parseFieldConfig(content.id).key;
                            const markers  = ref(content.marker)
                            // console.log("🚀 ~ handleChart ~ dataChart:", markers.value)
                            // console.log("🚀 ~ handleChart ~ dataChart:", dataChart[chartKey].xaxis)
                            markers.value.forEach((marker, index) => {
                                mapMarkers.value[`${mapKey}-${index}`] = {
                                        lat : marker[0]
                                    ,   long: marker[1] 
                                }
                                console.log("🚀 ~ extractMap ~ marker:", mapMarkers.value)
                            })


                        } catch (error) {
                            error
                            console.log("🚀 ~ extractMap ~ error:", error)
                        }
                    }

                    // Jika item ini punya sub-layout / nested layout
                    if (Array.isArray(content.layout)) {
                        extractMap(content.layout);
                    }

                    // Jika item ini punya array input
                    if (Array.isArray(content.input)) {
                        extractMap(content.input);
                    }
                });
            };

            extractMap(formConfig.value.layout);
        }

        // Configuration Calendar FullCalendar
        const calendarOptions   = computed(() => ({
            colorScheme     : CalendarDark.value
            , locales       : allLocales
            , plugins       : [ 
                classicThemePlugin
                , dayGridPlugin 
                , interactionPlugin
            ]
            , locale        : configCalendar.value.locale
            , initialView   : 'dayGridMonth'
            , selectable    : configCalendar.value.selectable
            , editable      : configCalendar.value.editable
            , events        : events.value
            , dateClick     : handleDateClick
            , eventClick    : handleEventClick
            , buttons       : {
                myCustomButton: {
                    text    : 'Add Events'
                    , click : handleCustomButton
                }
                , today     : {
                    text    : 'Today'
                }
            }
            , headerToolbar : {
                  start     : 'today myCustomButton'
                , center    : 'title'
                , end       : 'prev,next'
            }
        }))

        // Template references
        const videoRef  = ref(null);
        const canvasRef = ref(null);

        // Reactive state
        const capturedImage = ref(null);
        const imageBlob     = ref(null);
        const currentBG     = ref("")

        // const  {tools}      = useAllTools({ 
        //     backgroundImage: urlToBlob("https://picsum.photos/640/480"),
        //     backgroundColor: configPaint.value.backgroundColor
        // })
        const getRawTools = (toolsData) => {
            if (!toolsData) return []
            const list = Array.isArray(toolsData) ? toolsData : [toolsData]
            return list.map(t => markRaw(t))
        }

        const tools         = shallowRef(getRawTools(configPaint.value.tools))
        const history       = ref([])
        const settings      = createSettings(tools.value)
        const showPalette   = ref(false)
        const palette       = configPaint.value.colors.map(warna => warna)
        const editorKey     = ref(0)
        const urlVideo      = computed(() => configPaint.value?.url)

        const captureFrame  = async () => {
            // const newBlob   = await urlToBlob("https://picsum.photos/640/480") 
            // console.log("🚀 ~ captureFrame ~ tools:", tools.value)
            const bgidx     = tools.value.findIndex(t => t.type === 'background' || t.id === 'background');

            // Ambil elemen DOM dengan aman
            const video  = videoRef.value?.$el || (Array.isArray(videoRef.value) ? videoRef.value[0] : videoRef.value);
            const canvas = canvasRef.value?.$el || (Array.isArray(canvasRef.value) ? canvasRef.value[0] : canvasRef.value);

            if (!video || !canvas || typeof canvas.getContext !== 'function') return;

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                const dataUrl       = canvas.toDataURL('image/png');
                capturedImage.value = dataUrl;

                const newBlob   = await urlToBlob(dataUrl);

                // const Retools   = useAllTools({ 
                //     backgroundImage: newBlob
                // })
                const Retools   = useBackground({ blob: newBlob })
                
                // console.log("🚀 ~ captureFrame ~ bgidx:", bgidx)
                // console.log("🚀 ~ captureFrame ~ Retools:", Retools.tools)
                // console.log("🚀 ~ captureFrame ~ tools:", tools)

                // Update array tools with the new background image
                // tools.splice(bgidx, tools.length, ...Retools.tools)
                tools.value.splice(bgidx, 1, markRaw(Retools))

                history.value = []
                editorKey.value++

            }
        };

        function setColor(color) {
            settings.value.color = color
            showPalette.value    = false
        }

        const linkVideo = computed(() => configVideo.value)
        
        const initializeForm = () => {
            if (formConfig.value) {
                Object.keys(formData).forEach(key => delete formData[key])
                const initialData = new_initializeFormData(formConfig.value)
                
                // // Ensure all undefined properties default to null or empty string
                // Object.keys(initialData).forEach(key => {
                //     if (initialData[key] === undefined) {
                //         initialData[key] = ''
                //     }
                // })                
                // Object.assign(formData, initialData)
                const getFieldConfig = (key) => {
                let foundField = null;
                const search = (items) => {
                        if (!Array.isArray(items)) return;
                        for (const item of items) {
                            if (item.id && parseFieldConfig(item.id).key === key) {
                                foundField = item;
                                break;
                            }
                            if (item.layout) search(item.layout);
                            if (item.input) search(item.input);
                        }
                    };
                    search(formConfig.value.layout);
                    return foundField;
                };

                // Iterasi dan set default value
                Object.keys(initialData).forEach(key => {
                    const field = getFieldConfig(key);
                    
                    // Jika field bernilai undefined/null/kosong
                    if (!initialData[key]) {
                        if (field && field.type === 'date') {
                            // Ambil defaultDate dari prop config date_single/date_range
                            const dateCfg = field.config === 'range' ? props.date_range : props.date_single;
                            initialData[key] = dateCfg?.defaultDate || '';
                        } else {
                            initialData[key] = ''; // Default string kosong untuk non-date
                        }
                    }
                });

                Object.assign(formData, initialData);
            }
        }

        onMounted(() => {
            observer = new MutationObserver(() => {
                isDark.value = document.documentElement.classList.contains('dark')
            })
            observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
            initializeForm()
            handleChart()
            handleMap()
        })

        watch(
              () => props.config
            , () => initializeForm()
            , { deep: true }
            , () => {
                if (username.value && level.value.includes('karyawan')) {
                    formData.fullname = username.value
                }
            }
        )

        // Watch if isDark change to light or opposite status
        watch(isDark, (newVal) => {
            // Set Chart to Dark/Light mode
            handleChart()
        });    

        onUnmounted(() => {
            if (observer) observer.disconnect()
        })

        const isLoading           = ref(false)
        const errorMessage        = ref('')
        const successMessage      = ref('')
        const formRef             = ref(null)

        const containerWidthClass = computed(() => getContainerWidthClass(formConfig.value?.width))

        // AG-Grid State
        const rowData             = ref([])
        const columnDefs          = ref([])
        const hiddenFields        = ref([])

        // Modal State
        const isModalOpen         = ref(false)
        const selectedRowDetails  = ref({})
        
        const onRowDoubleClicked  = (event) => {
            selectedRowDetails.value = event.data
            isModalOpen.value        = true
        }

        // Try to trigger single click !!!
        const onRowSingleClicked = (event) => {
            selectedRowDetails.value = { ...event.data }
            // Implement to right chart if id is equal with json resp from api 
            if (event.data) {
                Object.assign(formData, event.data)
            }
            isModalOpen.value        = false
        }

        const closeModal = () => { isModalOpen.value = false }

        const onRowSaved = (updatedRow) => {
            const index = rowData.value.findIndex(row => row.id === updatedRow.id)
            if (index !== -1) {
                rowData.value[index] = { ...updatedRow }
                rowData.value        = [...rowData.value]
            }
        }

        const resetForm = () => {
            Object.keys(formData).forEach(key => formData[key] = '')
        }

        const getStateHelpers = () => ({
            setLoading : (val) => { isLoading.value = val },
            setError   : (msg) => { 
                errorMessage.value = msg
                console.log("🚀 ~ file: DynamicFormLayout.vue:189 ~ alert_type:", alert_type)
                if (msg && alert_type != 'classic') {
                    Swal.fire({
                         icon              : 'error'
                        ,title             : 'Error!'
                        // ,text              : msg
                        ,html              : msg
                        ,confirmButtonColor: '#6366f1'  // Matches indigo color scheme
                    })
                }
            },
            setSuccess: (msg) => { 
                successMessage.value = msg
                // Disable for SweetAlert for success 
                // if (msg && alert_type != 'classic') {
                //     Swal.fire({
                //         icon: 'success',
                //         title: 'Success!',
                //         text: msg,
                //         confirmButtonColor: '#6366f1',
                //         timer: 2500,
                //         timerProgressBar: true
                //     })
                // }
            }
            , formData
            , rowData
            , columnDefs
            , hiddenFields
        })       
        

        // const executeHandler = (handleName, submitField, event = null) => {
        const executeHandler = (handleName, submitField, event = null, section = null) => {
            // Try Simple One
            if (event && event.target && typeof event.target.reportValidity === 'function') {
                if (!event.target.reportValidity()) return
            }

            if (props.handlers && typeof props.handlers[handleName] === 'function') {
                // Pass 'section' as 4th parameter
                props.handlers[handleName](formData, getStateHelpers(), submitField, section)
                return
            }            
        }

        // Fixed Form Submit Handler
        const handleFormSubmit = (event, section) => {
            // let submitField = null
            // if (section.input) {
            //     submitField = section.input.find(f => f.button === 'submit')
            // } else if (section.layout) {
            //     for (const sub of section.layout) {
            //         if (sub.input) {
            //             submitField = sub.input.find(f => f.button === 'submit')
            //             if (submitField) break
            //         }
            //     }
            // }

            // const handleName = submitField?.handle || 'handleSubmit'
            // executeHandler(handleName, submitField, event)

            let submitField = null
            if (section.input) {
                submitField = section.input.find(f => f.button === 'submit')
            } else if (section.layout) {
                for (const sub of section.layout) {
                    if (sub.input) {
                        submitField = sub.input.find(f => f.button === 'submit')
                        if (submitField) break
                    }
                }
            }
            const handleName = submitField?.handle || 'handleSubmit'
            executeHandler(handleName, submitField, event, section)
        }

        // Fixed Button Click Handler
        const handleButtonClick = (field) => {
            if (field.button === 'reset') {
                resetForm()
                return
            }
            
            // Only process non-submit button clicks here (submit buttons are handled by handleFormSubmit)
            if (field.button !== 'submit') {
                const handleName = field.handle || 'handleSubmit'
                executeHandler(handleName, field)
            }
        }

        return {
              formConfig
            , formData
            , activeTabIndex
            , isLoading
            , errorMessage
            , successMessage
            , containerWidthClass
            , parseFieldConfig
            , handleButtonClick

            , handleFormSubmit
            , resetForm
            , lottieLoading
            , alert_type
            // , DateConfig
            , DateSingle
            , DateRange
            , DateMulti
            , DateTime
            , TimePicker
            , typeMenu

            , calendarOptions
            , tools
            , history
            , settings
            , showPalette
            , palette
            , setColor
            , videoRef
            , canvasRef
            , capturedImage
            , currentBG
            , editorKey
            , urlVideo
            , captureFrame

            , linkVideo
            , rawMetrics
            , getFlexStyle
            , handleChart

            , mapMarkers

            , getGridStyle
            , rowData
            , defaultColDef
            , columnDefs
            , AgGridDark
            , paginationPageSize
            , paginationPageSizeSelector
            , onRowDoubleClicked
            , onRowSingleClicked
            , onRowSaved
            , hiddenFields

            , directRow
            , directColumn
            , directHidden
            , directLoading
            , isCheckModal
            , directCustomCol
            , directCustomFor

            , isModalOpen
            , selectedRowDetails
            , closeModal
            , getSectionWidthStyle
            , formRef
            , moment
        }
    }
})

function sanitizeInput(val) {
    if (typeof val === 'string') return DOMPurify.sanitize(val.trim())
    return val
}
</script>

<style scoped>
:deep(.vp-action-save) {
  display: none;
}
:deep(.vp-toolbar button) {
  border-radius: 15%;
  margin-right: 10px;
}
:deep(.vp-tools) {
  font-size: xx-large;
}
:deep(.vp-setting-thickness) {
  margin-right: 10px;
}
:deep(.vp-settings button) {
  border: 1px solid black;
}
:deep(.vp-actions button img) {
  width: 40px;
  height: 40px;
  background-color: white;
}
.color {
  width: 30px;
  height: 30px;
  border-radius: 15%;
}
:deep(.ql-toolbar.ql-snow) {
  background-color: #1e293b !important;
  border-color: #334155 !important;
}
:deep(.ql-toolbar.ql-snow .ql-stroke) {
  stroke: #f1f5f9 !important;
}
:deep(.ql-toolbar.ql-snow .ql-fill) {
  fill: #f1f5f9 !important;
}
:deep(.ql-toolbar.ql-snow .ql-picker) {
  color: #f1f5f9 !important;
}
:deep(.ql-container.ql-snow) {
  border-color: #334155 !important;
  color: #f8fafc !important;
  min-height: 200px;
}
</style>

<!-- Style Global (Tanpa scoped) khusus Overrides Third-Party UI (v-select, flatpickr, dll) -->
<style>
/* Light mode text & autofill defaults */
input, select {
    color: #0f172a !important;
    -webkit-text-fill-color: #0f172a !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
    -webkit-text-fill-color: #0f172a !important;
    caret-color: #0f172a !important;
    transition: background-color 5000s ease-in-out 0s;
}

/* Dark mode text & autofill overrides */
.dark input, .dark select {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
}

.dark input:focus,
.dark input:active {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
}

.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover, 
.dark input:-webkit-autofill:focus, 
.dark input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #1e293b inset !important;
    -webkit-text-fill-color: #ffffff !important;
    caret-color: #ffffff !important;
    transition: background-color 5000s ease-in-out 0s;
}

/* Flatpickr Dark Mode Overrides */
.dark .flatpickr-calendar {
    background: #0f172a !important;
    border-color: #334155 !important;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -4px rgba(0, 0, 0, 0.5) !important;
}
.dark .flatpickr-calendar.arrowTop:before,
.dark .flatpickr-calendar.arrowTop:after {
    border-bottom-color: #0f172a !important;
}
.dark .flatpickr-months .flatpickr-month,
.dark .flatpickr-months .flatpickr-prev-month,
.dark .flatpickr-months .flatpickr-next-month,
.dark span.flatpickr-weekday {
    background: #0f172a !important;
    color: #cbd5e1 !important;
    fill: #cbd5e1 !important;
}
.dark .flatpickr-day {
    color: #e2e8f0 !important;
}
.dark .flatpickr-day:hover,
.dark .flatpickr-day:focus {
    background: #1e293b !important;
    border-color: #334155 !important;
}
.dark .flatpickr-day.flatpickr-disabled,
.dark .flatpickr-day.prevMonthDay,
.dark .flatpickr-day.nextMonthDay {
    color: #475569 !important;
}
.dark .flatpickr-day.today {
    border-color: #6366f1 !important;
}
.dark .flatpickr-day.selected,
.dark .flatpickr-day.startRange,
.dark .flatpickr-day.endRange {
    background: #6366f1 !important;
    border-color: #6366f1 !important;
    color: #ffffff !important;
}
.dark .flatpickr-day.inRange {
    background: #312e81 !important;
    box-shadow: -5px 0 0 #312e81, 5px 0 0 #312e81 !important;
    color: #e0e7ff !important;
}

/* VueSelect Dark Mode Overrides (GLOBAL) */
.dark .v-select {
    background-color: #1e293b;
    color: #f8fafc;
}
.dark .vs__dropdown-toggle {
    border-color: #334155;
    background-color: #0f172a;
    height: 45px;
}
.dark .vs__selected,
.dark .vs__input,
.dark .vs__search {
    color: #f8fafc !important;
    -webkit-text-fill-color: #f8fafc !important;
}
.dark .vs__dropdown-menu {
    background-color: #0f172a;
    border-color: #334155;
}
.dark .vs__dropdown-option {
    color: #cbd5e1;
}
.dark .vs__dropdown-option--highlight {
    background-color: #6366f1;
    color: #ffffff;
}
.dark .vs__open-indicator,
.dark .vs__clear {
    fill: #94a3b8;
}
</style>